require('!!raw-loader!/builds/664808/v2/src/index.html');